'use client'

import { useMemo } from 'react'

import {
  type CreditPriceView,
  formatMinorUnits,
} from '@/features/settings/billing/credits/lib/credits'
import { useNumberFormat } from '@/hooks/use-number-format'
import { type FormatOptions } from '@/lib/number-format'

/**
 * Credit amounts are the user's account, so they mask with hide-balances; prices are public,
 * so `cost` never does.
 */
export function useCreditFormat() {
  const fmt = useNumberFormat()
  return useMemo(
    () => ({
      credits: (value: number, options?: FormatOptions) =>
        fmt.number(value, { ...options, sensitive: true }),
      /** What `credits` cost at the per-credit price, e.g. "$50.00". */
      cost: (price: CreditPriceView, credits: number) => {
        const { value, currency } = formatMinorUnits(credits * price.unitAmount, price.currency)
        return fmt.number(value, { style: 'currency', currency })
      },
    }),
    [fmt]
  )
}
